


















































import { Component, Vue, Prop } from 'vue-property-decorator';
import PersonData from '@/ts/PersonData';
import FeedItemData from '@/ts/FeedItemData';

@Component
export default class FeedItem extends Vue {
    @Prop() public feedItemData!: FeedItemData;

    constructor() {
        super();
    }

    get authorName(): string {
        const  author = this.getUser(this.feedItemData.authorId);

        if (!author) {
            return '';
        }

        return author.name;
    }

    public getUser(userId: number): PersonData {
        return this.$store.getters['User/getCacheUser'](userId);
    }

    public getCalendarEvent(eventId: number) {
        return this.$store.getters['Notifications/getCalendarEvent'](eventId);
    }

    get dateString(): string {
        if (!this.feedItemData.event) {
            // TODO (CKJ): Fjern i production
            return 'Jeg bør ikke være her, ring til Caspar (30254158)';
        }

        return this.feedItemData.event.toString();
    }
}
